import React, { useState } from "react";
import "./AgencyProfileLogo.scss";
import { Typography, IconButton, Box, CircularProgress } from "@mui/material";
import { BrandApi } from "../../../../utils/api/Brand";
import toast from "react-hot-toast";
import { getCdnImageUrl, getImageUrl } from "../../../../utils/helpers/common";
import Upload from "../../../../components/icons/Upload";
import { useSearchParams } from "react-router-dom";

const BrandProfileLogo = ({ formik, brandId, setBrandId }: any) => {
  const [isDragging, setIsDragging] = useState(false);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const getLogoDisplayUrl = () => {
    const uploadRecord = formik.values.brandLogoUploadRecord;

    if (uploadRecord) {
      if (uploadRecord.storage_key) {
        return getCdnImageUrl(uploadRecord.storage_key);
      }
      if (uploadRecord.original_file_path) {
        return getImageUrl(uploadRecord.original_file_path);
      }
    }

    if (
      formik.values.brand_logo &&
      typeof formik.values.brand_logo === "string"
    ) {
      return getImageUrl(formik.values.brand_logo);
    }

    return "";
  };

  const handleImageChange = async (file?: File) => {
    if (!file) {
      toast.error("Please select a logo");
      return;
    }

    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      toast.error("Only PNG, JPG or JPEG allowed");
      return;
    }

    const formData = new FormData();
    formData.append("brand_logo", file);

    setIsLoadingUpload(true);

    try {
      const res = brandId
        ? await BrandApi.updateBrandLogo(brandId, formData)
        : await BrandApi.createBrandByLogoOnly(formData);

      if (!res.success) {
        toast.error(res.error || "Upload failed");
        return;
      }

      const payload = res.data?.data;
      const uploadRecord = payload?.brand_logo || payload?.upload_record;

      if (!brandId && payload?.brand_id) {
        // setBrandId?.(payload.brand_id);
        // formik.setFieldValue("brand_id", payload.brand_id);

        setSearchParams({ id: payload.brand_id });
      }

      const logoPath =
        payload?.brand_logo?.original_file_path ||
        payload?.upload_record?.original_file_path ||
        null;

      // formik.setFieldValue("brand_logo", logoPath);
      formik.setFieldValue(
        "brand_logo",
        uploadRecord?._id || uploadRecord?.original_file_path || null,
      );
      formik.setFieldValue("brandLogoUploadRecord", uploadRecord || null);
      formik.setFieldValue("theme_colors", payload?.theme_colors || [], true);
      formik.setFieldValue(
        "theme_colors_response",
        payload?.theme_colors || [],
      );

      formik.setFieldValue(
        "base_color_primary",
        payload?.base_color_primary,
        true,
      );
      formik.setFieldValue(
        "base_color_secondary",
        payload?.base_color_secondary,
        true,
      );
      formik.setFieldValue(
        "text_color_primary",
        payload?.text_color_primary,
        true,
      );
      formik.setFieldValue(
        "text_color_secondary",
        payload?.text_color_secondary,
        true,
      );

      formik.setFieldValue("baseColor", payload?.base_color_primary?.hex);

      toast.success(
        brandId
          ? "Brand logo updated successfully"
          : "Brand logo uploaded successfully",
      );
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setIsLoadingUpload(false);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    handleImageChange(e.dataTransfer.files[0]);
  };

  return (
    <div className="agency-profile-logo-container">
      {formik.values.brand_logo ? (
        <Box>
          <div className="profile-image-container">
            <img src={getLogoDisplayUrl()} alt="Brand Logo" />
          </div>

          <Box mt={2}>
            <Box mt={2}>
              <label className="update-button">
                {isLoadingUpload ? (
                  <div className="black-color-circular-progress">
                    <CircularProgress size={22} />
                  </div>
                ) : (
                  "Change brand logo"
                )}

                <input
                  type="file"
                  hidden
                  disabled={isLoadingUpload}
                  onChange={(e) => handleImageChange(e.target.files?.[0])}
                />
              </label>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          className={`profile-picture-upload ${isDragging ? "dragging" : ""}`}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={() => setIsDragging(true)}
          onDragLeave={() => setIsDragging(false)}
          onDrop={handleDrop}
        >
          <Box component="label" className="upload-box">
            <input
              type="file"
              hidden
              disabled={isLoadingUpload}
              onChange={(e) => handleImageChange(e.target.files?.[0])}
            />

            <Box className="upload-content">
              <IconButton size="large">
                <div className="icon-wrapper">
                  {isLoadingUpload ? (
                    <div className="black-color-circular-progress">
                      <CircularProgress size={28} />
                    </div>
                  ) : (
                    <Upload />
                  )}
                </div>
              </IconButton>

              <Typography variant="body2">
                {isDragging ? "Release to upload" : "Drop or Select file"}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default BrandProfileLogo;
